const isLoadingSelector = rdxState =>
  rdxState &&
  ((rdxState.codeReducer && rdxState.codeReducer.isLoading) ||
    (rdxState.viewImgReducer && rdxState.viewImgReducer.isLoading));

export { isLoadingSelector };
